import { useContext } from "react";
import { useConnectDemoAccountRequest } from "src/services/demo/commands/connect-account";

import Context from "../context";
import useGetConnectUpdateService from "./useGetConnectUpdateService";

export type ConnectAccountResponse = {
	message: string;
	uniqueId: string;
	status: string;
	redirectUri: string;
	token: string;
};
export const CodeErrors = [
	"bad_credentials",
	"blocked_account",
	"credentials_exist",
	"missing_creds",
	"wrong_totp",
	"wrong_confirmation",
	"user_action_needed"
];

export default function useSelectServiceConnect() {
	const { id, product, customConnectProps } = useContext(Context);
	const { onConnect } = customConnectProps!;

	const demoRequest = useConnectDemoAccountRequest(id);

	const connectRequest = useGetConnectUpdateService();

	const connectSuccess = (
		data: ConnectAccountResponse,
		onSuccess: (data: ConnectAccountResponse) => void
	) => {
		if (
			!data.status ||
			(data.status && data.status !== "totp_needed" && data.status !== "user_confirmation_needed")
		)
			onConnect(data.token, data.redirectUri);
		onSuccess(data);
	};

	const mutate = (
		data: any,
		onSuccess: (data: ConnectAccountResponse) => void,
		onError: (error: any) => void
	) => {
		product
			? demoRequest.mutate(
					{ ...data, product },
					{ onSuccess: (data) => connectSuccess(data, onSuccess), onError }
			  )
			: connectRequest.mutate(data, {
					onSuccess: (data) => connectSuccess(data, onSuccess),
					onError
			  });
	};

	return {
		mutate
	};
}
